import request from 'api/request';

export default function createShiftRoute(data) {
  return request({ url: '/shifts', method: 'POST', data });
}
